import { Chip } from "@mui/material";

interface VersionBadgeProps {
  version: string;
  status: "active" | "draft" | "archived";
}

export const VersionBadge = ({ version, status }: VersionBadgeProps) => {
  const getColor = () => {
    switch (status) {
      case "active":
        return "success";
      case "draft":
        return "warning";
      case "archived":
        return "default";
      default:
        return "default";
    }
  };

  const getLabel = () => {
    if (status === "draft") {
      return "Draft";
    }
    return `v${version}`;
  };

  return (
    <Chip
      label={getLabel()}
      color={getColor()}
      size="small"
      sx={{ fontWeight: 500 }}
    />
  );
};
